jQuery(document).ready(function(){
	// Enable and disable Preloader Form
	var overlayBox = jQuery('.overlay-box');
	if(overlayBox.length > 0) {
		overlayBox.css({
			'top': 0
		});
	}else{
		closeTheStage();
	}
	
	if(jQuery('#load-first').data('loadfirst') == 1 && jQuery('#enable-preloader').data('enablepreloader') == 1) {
		massInit();
		setTimeout("jQuery('.overlay-box').css('display','block')", 2000);
		
		setTimeout("jQuery('.preloader_form').css('visibility','inherit')", 1000);
	}
	
	jQuery('#logo-preloader').css('visibility','visible');
	
	jQuery('#select_user_to_edit_form').remove();
	var cpClipboard = jQuery('.copy-button');
	var clipboard = new Clipboard('#cpClipboard');
	cpClipboard.each(function(i){
			
	});
	clipboard.on('success', function(e) {
		var elem = e.trigger;
		var id = elem.getAttribute('data-id');
		jQuery('#'+id).show();
		setTimeout(function(){
			jQuery('#'+id).hide();
		}, 1000);
	});
	
	
	jQuery("#upload_floorplan .acf-button.add-attachment").html('Upload Floor Plan');
	jQuery("#upload_photos_model .acf-button.add-attachment").html('Upload Photos');
	var idPreloaderForm = jQuery('#preloader_form_id').val();
	var form = jQuery('#gform_3');
	var cancelBtn = '<input type="button" id="btnCancel" class="gform_button button" value="Skip this">';
	var buttonBox = jQuery('#gform_'+idPreloaderForm+' .gform_footer');
	var btnCancelEl = jQuery('#btnCancel');
	var btnSubmit = jQuery('#gform_submit_button_3');
	
	if(overlayBox.data('mandatory') != true) {
		buttonBox.append(cancelBtn);
	}
	
	
	jQuery(document).on('click', '#btnCancel', function(){
		closeTheStage();
	});
	
	btnSubmit.click(function(e){
	    e.preventDefault();
	    var data = {
	        'action': 'gform_signup',
	        'form_data': form.serialize()
	    };
	    
	    jQuery.post(fix_frontend.ajaxurl, data, function(response){
	        if (response == 'success') {
	            form.hide();
	            form.after('<span class="success-alert">Thanks for subscribe!</span>');
	            form.submit();
    			setTimeout(function(){
    				overlayBox.toggle( "drop" );
    			}, 4000);
    			massInit();
	        } else {
	            form.after('<span class="error">You have fill out all the fields.</span>');
	        }
	    });
	});
	
    

	// update class for dashboard page
    var pageClass;
    var tab;
    var url = window.location.href;
    
    tab = getParameterByName('profile', url);
    //console.log(tab);
    switch (tab) {
        case 'account':
            pageClass = "my_account";
            break;
        case 'item':
            pageClass = "my_items";
            break;
        default:
            pageClass = "";
            break;
            
    }
    jQuery("body").addClass(pageClass);

	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function copyToClipboard(elem) {
		  // create hidden text element, if it doesn't already exist
	    var targetId = "_hiddenCopyText_";
	    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
	    var origSelectionStart, origSelectionEnd;
	    if (isInput) {
	        // can just use the original source element for the selection and copy
	        target = elem;
	        origSelectionStart = elem.selectionStart;
	        origSelectionEnd = elem.selectionEnd;
	    } else {
	        // must use a temporary form element for the selection and copy
	        target = document.getElementById(targetId);
	        if (!target) {
	            var target = document.createElement("textarea");
	            target.style.position = "absolute";
	            target.style.left = "-9999px";
	            target.style.top = "0";
	            target.id = targetId;
	            document.body.appendChild(target);
	        }
	        target.textContent = elem.textContent;
	    }
	    // select the content
	    var currentFocus = document.activeElement;
	    target.focus();
	    target.setSelectionRange(0, target.value.length);
	    
	    // copy the selection
	    var succeed;
	    try {
	    	  succeed = document.execCommand("copy");
	    } catch(e) {
	        succeed = false;
	    }
	    // restore original focus
	    if (currentFocus && typeof currentFocus.focus === "function") {
	        currentFocus.focus();
	    }
	    
	    if (isInput) {
	        // restore prior selection
	        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
	    } else {
	        // clear temporary content
	        target.textContent = "";
	    }
	    return succeed;
	}
});

function closeTheStage() {
	jQuery('.overlay-box').toggle( "hide" );
	massInit();
}


function massInit()
    {
    	var container = document.getElementById( 'ip-container' );
    	if(container === null) return;
		var support = { animations : Modernizr.cssanimations },
		header = container.querySelector( 'header.ip-header' ),
		loader = new PathLoader( document.getElementById( 'ip-loader-circle' ) ),
		animEndEventNames = { 'WebkitAnimation' : 'webkitAnimationEnd', 'OAnimation' : 'oAnimationEnd', 'msAnimation' : 'MSAnimationEnd', 'animation' : 'animationend' },
		// animation end event name
		animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ];

		function init() {
			var onEndInitialAnimation = function() {
				if( support.animations ) {
					this.removeEventListener( animEndEventName, onEndInitialAnimation );
				}

				startLoading();
			};

    		// disable scrolling
    		window.addEventListener( 'scroll', noscroll );
    
    		// initial animation
    		classie.add( container, 'loading' );
    
    		if( support.animations ) {
    			container.addEventListener( animEndEventName, onEndInitialAnimation );
    		}
    		else {
    			onEndInitialAnimation();
    		}
    	}

    	function startLoading() {
    		// simulate loading something..
    		var simulationFn = function(instance) {
    			var progress = 0,
    				duration = jQuery('#ip-container').data('duration');
    			interval = setInterval( function() {
    				progress = Math.min( progress + Math.random() * 1/(duration*2), 1 );
    
    					//console.log(progress);
    
    					instance.setProgress( progress );
    
    					// reached the end
    					if( progress === 1 ) {
    						classie.remove( container, 'loading' );
    						classie.add( container, 'loaded' );
    						clearInterval( interval );
    
    						var onEndHeaderAnimation = function(ev) {
    							if( support.animations ) {
    								if( ev.target !== header ) return;
    								this.removeEventListener( animEndEventName, onEndHeaderAnimation );
    							}
    
    							classie.add( document.body, 'layout-switch' );
    							window.removeEventListener( 'scroll', noscroll );
    						};
    
    						if( support.animations ) {
    							header.addEventListener( animEndEventName, onEndHeaderAnimation );
    						}
    						else {
    							onEndHeaderAnimation();
    						}
    					}
    				}, 250 );
    		};
    
    		loader.setProgressFn( simulationFn );
    	}
    	
    	function noscroll() {
    		window.scrollTo( 0, 0 );
    	}
    
    	init();
    }
